import { api } from './api';

const TIMEOUT = 15000;

export const insightsAPI = {
  access:     async () => (await api.get('/intelligence/access',     { timeout: TIMEOUT })).data,
  overview:   async () => (await api.get('/intelligence/overview',   { timeout: TIMEOUT })).data,
  byUser:     async () => (await api.get('/intelligence/by-user',    { timeout: TIMEOUT })).data,
  activity:   async (limit = 30) =>
    (await api.get('/intelligence/activity',   { params: { limit }, timeout: TIMEOUT })).data,
  topTenders: async (limit = 20) =>
    (await api.get('/intelligence/top-tenders', { params: { limit }, timeout: TIMEOUT })).data,
  userTenders: async (userId, limit = 500) =>
    (await api.get(`/intelligence/user/${encodeURIComponent(userId)}/tenders`,
      { params: { limit }, timeout: TIMEOUT })).data,
};
